<template>
  <v-container id="dinamicas" tag="section">
    <base-v-component :heading="title" />
    <base-material-card
      color="indigo"
      icon="mdi-newspaper"
      inline
      class="px-5 py-3"
    >
      <v-card-title>
        <v-spacer />
        <v-btn :loading="loading" class="primary" text @click="save"
          >Guardar</v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="pagina.nombreComponente"
              label="Nombre del componente"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field v-model="pagina.titulo" label="Título de la página" />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field v-model="pagina.path" label="Ruta" />
          </v-col>
          <v-col cols="12" sm="9">
            <v-text-field
              v-model="pagina.descripcion"
              label="Descripcion de la página"
            />
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="pagina.nombreMenu"
              label="Nombre en el menú"
            />
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <v-checkbox v-model="pagina.menuUsuario" label="Menú usuario" />
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <v-checkbox v-model="pagina.menuSuperior" label="Menú superior" />
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <v-checkbox v-model="pagina.menuDrawer" label="Menú drawer" />
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <v-text-field
              v-if="pagina.menuDrawer"
              v-model="pagina.menuDrawerIcon"
              label="Icono menú drawer"
            />
          </v-col>
        </v-row>
        <span class="v-label theme--light">Código</span>
        <prism-editor
          :ignoreTabKey="true"
          :insertSpaces="false"
          class="my-editor"
          v-model="pagina.code"
          :highlight="highlighter"
          line-numbers
        ></prism-editor>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </base-material-card>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState, mapGetters, mapActions } from "vuex";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css"; // import syntax highlighting styles

export default {
  components: { PrismEditor },
  mixins: [validationMixin],
  validations: {
    titulo: { required },
    fecha: { required },
    hora: { required },
  },
  data() {
    return {
      loading: false,
      pagina: {
        id: null,
        nombreComponente: "",
        titulo: "",
        descripcion: "",
        menuUsuario: false,
        menuSuperior: false,
        menuDrawer: false,
        path: "",
        code: "<template>\n</template>\n<script>",
      },
    };
  },
  computed: {
    codeComputado() {
      /*var template = this.pagina.code
        .replace(/[\n\t\r]/g, "")
        .match(new RegExp("<template>" + "(.*)" + "</template>"));

      var script = this.pagina.code
        .replace(/[\n\t\r]/g, "")
        .match(new RegExp("<scrip>" + "(.*)" + "</scrip>"));
      return {
        template: template[1],
        script: script[1],
      };*/
      return ""; //eval("(function() { return " + this.pagina.code + "}())");
    },
    title() {
      return this.isEdit
        ? "Editar Página Dinámica " + this.id
        : "Nueva Página Dinámica";
    },
    isEdit() {
      return this.id != null;
    },
    ...mapState({
      langDefecto: "langDefecto",
      // negocioObj: (state) => state.app.negocioObjGest,
      negocioGest: (state) => state.app.negocioGest,
      directorioGest: (state) => state.app.directorioGest,
      negocioObjBruto: (state) => state.app.negocioObjGest,
      directorioObjBruto: (state) => state.app.directorioObjGest,
    }),
    paginasDinamicas() {
      return this.negocioObj.web && this.negocioObj.web.paginasDinamicas
        ? this.negocioObj.web.paginasDinamicas
        : [];
    },
    negocioObj() {
      return this.negocioGest
        ? this.negocioObjBruto
        : this.directorioObjBruto
        ? this.directorioObjBruto
        : null;
    },
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.js); //returns html
    },
    save() {
      let _vm = this;
      _vm.loading = true;
      this.pagina.codeComputado = JSON.stringify(this.codeComputado);
      if (this.pagina.id) {
        var found = this.paginasDinamicas.findIndex(
          (p) => p.id == this.pagina.id
        );
        if (found > -1) {
          this.paginasDinamicas[found] = this.pagina;
        }
      } else {
        this.pagina.id = this.pagina.nombreComponente;
        this.paginasDinamicas.push(this.pagina);
      }
      /*this.$store
        .dispatch("propio/generarComponente", _vm.pagina)
        .then((r) => {*/
      return (
        this.$store
          .dispatch("propio/savePaginaDinamica", _vm.paginasDinamicas)
          //})
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Página grabada con éxito",
            });
            return this.getNegDirGest();
          })
          .catch((error) => {
            console.log(error);
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al guardar la página",
            });
          })
          .finally(() => {
            _vm.loading = false;
          })
      );
    },
    getNegDirGest() {
      if (this.$store.getters["app/esNegocio"]) {
        return this.$store.dispatch("negocios/getNegocioBoss");
      } else if (this.$store.getters["app/esDirectorio"]) {
        return this.$store.dispatch("directorios/getDirectorioGest");
      }
    },
  },
  mounted() {
    if (this.$route.params.id) {
      let id = this.$route.params.id;
      let found = this.paginasDinamicas.find((p) => p.id == id);
      if (found) {
        this.pagina = found;
        this.pagina.id = id;
      } else {
        if (this.negocioGest) {
          this.$router.push("/admin/gest/" + this.negocioGest + "/web");
        } else if (this.directorioGest) {
          this.$router.push(
            "/admin/directorio/" + this.directorioGest + "/web"
          );
        }
      }
    }
  },
};
</script>

<style>
/* required class */
.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}
</style> 